// extracted by mini-css-extract-plugin
export default {"lableStyle":"CommonLabel_lableStyle__Cp8xr"};